export default "__VITE_ASSET__CXdb7Hgz__"